import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ProductCategoryDetailService } from './detail.service';
import { ProductCategoryUpdateStatusService } from './update-status.service';

import { DialogHelper, ExceptionHelper } from './../../../../helper';
import { ProductCategory } from '../../../../model';
import * as $ from 'jquery';

@Component({
    templateUrl: './detail.component.html'
})
export class ProductCategoryDetailComponent implements OnInit {
    id = ''; // product category id
    model = new ProductCategory();

    constructor(
      private dialog: DialogHelper,
      private exception: ExceptionHelper,
      private productCatDetailService: ProductCategoryDetailService,
      private productCategoryUpdateStatusService: ProductCategoryUpdateStatusService,
      private route: ActivatedRoute,
      private router: Router,
      private translate: TranslateService
    ) {
        this.translate.setDefaultLang('en-us');
        this.route.params.subscribe(params => {
            this.id = params['id'];
        });
    }

    ngOnInit() {
        this.getDetail();
    }

    getDetail() {
      this.productCatDetailService
      .getDetail(this.id)
      .subscribe(
        data => {
          if (data) {
            this.model = data;
          }
        },
        err => {
          $('.card').hide();
          this.exception.showError(err, 'showDanModalBtn');
        }
      );
    }

    activate() { 
      if (this.model.isActive == '0') {
        this.updateStatus();
      }
      else {
        this.exception.showError(null, 'showDanModalBtn');
      }

    }

    deactivate() { 
      if (this.model.isActive == '1') {
        this.updateStatus();
      }
      else {
        this.exception.showError(null, 'showDanModalBtn');
      }

    }

    updateStatus() {
      this.productCategoryUpdateStatusService.update(this.id).subscribe(data => {
         
        this.dialog.showModal('showSucModalBtn');
        this.model = data;
        
      },
      error => {
        this.exception.showError(error, 'showDanModalBtn');
      });

    }


    errorClose() {
      this.router.navigate(['/home/product-category']);
    }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/detail/detail.component.ts